import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DialogChangesService {
  private readonly hasChangesSubject = new BehaviorSubject<boolean>(false);
  hasChanges$ = this.hasChangesSubject.asObservable();
  setChanges(hasChanges: boolean): void {
    this.hasChangesSubject.next(hasChanges);
  }
}
